import { useEffect, useState } from 'react'
import axios from 'axios'
import { commonMessage, statusCodes,  } from '../../../Constants/generalConfig'
import { durationList,durationStatus,durationDelete } from '../../../Context/api'
import { toast } from 'react-toastify'

const UseServiceDuration = () => {
    const [duration, setDuration] = useState([])
    const [spinner, setSpinner] = useState(false)
    const [deleteShow, setDeleteShow] = useState({open:false,data:''})
    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));

    useEffect(() => {
        listDuration()
    }, [page])

    const listDuration = () => {
        const data = {
            userId: adminData?.userId,
            isDeleted: false,
            page: page,
            count: PER_PAGE,
        }
        setSpinner(true)
        axios.post(durationList(), { ...data }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setDuration(resp.data.data)
                setCount(resp.data.totalCount)
                setSpinner(false)
            }
            else {
                setDuration([])
                setSpinner(false)
            }
        }).catch(() => {
            setSpinner(false)
            toast.error(commonMessage.networkError)
        })
    }

    const deleteDuration = () => {
        setSpinner(true)
        axios.post(durationDelete(), { durationId: deleteShow?.data?._id }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                listDuration()
                setSpinner(false)
                setDeleteShow({open:false,data:''})
            }
            else {
                setSpinner(false)
                toast.error(resp.data.message)
            }
        })
    }
    const statusChange = (item) => {
        setSpinner(true)
        axios.post(durationStatus(), { id: item._id, isActive: !item.isActive, userId: adminData?.userId }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                listDuration()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        }).catch(() => {
            setSpinner(false)
            toast.error(commonMessage.networkError)
        })
    }
    return {
        setPage,
        statusChange,
        setDeleteShow,
        deleteDuration,
        deleteShow, 
        count,
        duration,
        PER_PAGE,
        page,
        spinner,
    }
}

export default UseServiceDuration
